import React from "react";
import "../style/trauma-care.css";
import Servicessidebar from "../components/servicessidebar";

const TraumaCare = () => {
    const specialists = [
        "Trauma Surgeon General",
        "Vascular Surgeon",
        "Plastic and Cosmetic Surgeon",
        "Orthopedic Surgeon",
        "Thoracic Surgeon",
        "Neuro Surgeon",
        "Intensivist",
        "Committed paramedical staff",
        "Emergency officers and technicians",
        "Back-end support with emergency investigating units working 24x7"
    ];

    return (
        <div className="tc-wrapper">
            <div className="container">
                <div className="trauma-care-je">
                    <div className="tc-left">
                        <h2 className="tc-title">Trauma Care Centre</h2>

                        <p className="tc-text">
                            Exclusive trauma care centre consisting of:
                        </p>

                        <ul className="tc-list">
                            {specialists.map((item, index) => (
                                <li key={index} className="tc-item">
                                    <span className="tc-icon">➤</span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="tc-right">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TraumaCare;
